import React from 'react';

const PortfolioSubFormModal = React.lazy(() => import('../components/FormModal'));
const portfolioSubModalRegistry = {
    personalize_portfolioSubId: PortfolioSubFormModal
};
export default portfolioSubModalRegistry;
